$(document).ready(function () {
	const $sub_menu_btn_hover = $('.menu li.dropdown-hover');
	const $sub_menu_hover = $('.menu li.dropdown-hover > ul.sub-menu');
	const $hover_speed = '200';

	//sub menu button click mobile

	$('.dropdown-hover').on('click touch', function (e) {
		// e.preventDefault(); // this needs to be applied in Dropdown Heading/Sub Menu heading
		e.stopPropagation();
		$('.dropdown-hover').toggleClass('dropdown-hover-open');
		if ($('.dropdown-hover').hasClass('dropdown-hover-open')) {
			$sub_menu_hover.slideUp($hover_speed);
		} else {
			$sub_menu_hover.slideDown($hover_speed);
		}
	});

	//sub menu button hover accessibility
	$sub_menu_btn_hover.on('keydown', function (e) {
		if (e.keyCode === 27) {
			// ESC
			$sub_menu_hover.slideUp($hover_speed);
		}
		// if (e.keyCode === 13) {
		// 	// Enter
		// 	$sub_menu_hover.slideToggle('400');
		// }
	});

	// $('.dropdown-hover').on('mouseenter', function() {
	// 	$sub_menu_hover.slideDown('400');
	// 	$(this).addClass('dropdown-hover-open');
	// });
	// $('.dropdown-hover').on('mouseleave', function() {
	// 	$sub_menu_hover.slideUp('400');
	// 	$(this).removeClass('dropdown-hover-open');
	// });

	$('.dropdown-hover').hover(
		function () {
			$('.dropdown-hover .sub-menu')
				.not('.in .dropdown-hover')
				.stop(true, true)
				.slideDown($hover_speed);
			$(this).addClass('dropdown-hover-open');
			//hides any open .dropdown-click items when .dropdown-hover is hovered
			$('.menu > li.dropdown-click > ul.sub-menu').slideUp($hover_speed);
		},
		function () {
			$('.dropdown-hover .sub-menu')
				.not('.in .dropdown-hover')
				.stop(true, true)
				.slideUp($hover_speed);
			$(this).removeClass('dropdown-hover-open');
		}
	);
});
